/* eslint-disable no-shadow */
import dayjs from 'dayjs';

dayjs.extend(require('dayjs/plugin/customParseFormat'));

const formatDateFromIso = localStartTimeIso => dayjs(localStartTimeIso).format('dddd MMM D, YYYY');

const getDateAndTimeFromIso = (startTime) => ({
  date: formatDateFromIso(startTime),
  time: dayjs(startTime, 'YYYY-MM-DDTHH:mm:ss').format('h:mm A'),
});

export const formatTimeslots = timeslots =>
  timeslots.reduce((formattedTimeslots, timeslot) => {
    const { optionId, routeId, localStartTimeIso } = timeslot;
    const { date, time } = getDateAndTimeFromIso(localStartTimeIso);
    const slot = { optionId, routeId, time };
    const dateIndex = formattedTimeslots.findIndex(slot => slot.date === date);

    if (dateIndex !== -1) {
      formattedTimeslots[dateIndex].times.push(slot);
    } else {
      formattedTimeslots.push({ date, times: [slot] });
    }

    return formattedTimeslots;
  }, []);

  export const formatTimeWindows = timeWindows =>
  timeWindows.reduce((formattedTimeWindows, timeWindows) => {
    const { optionId, routeId, windowStartTimeIso, windowEndTimeIso } = timeWindows;

    const { date, time } = getDateAndTimeFromIso(windowStartTimeIso);
    const endRange = dayjs(windowEndTimeIso, 'YYYY-MM-DDTHH:mm:ss').format('h:mm A');

    const window = { optionId, routeId, time, endRange };
    const dateIndex = formattedTimeWindows.findIndex(window => window.date === date);

    if (dateIndex !== -1) {
      formattedTimeWindows[dateIndex].times.push(window);
    } else {
      formattedTimeWindows.push({ date, times: [window] });
    }

    return formattedTimeWindows;
  }, []);

export const getPreferredTimeslotIndex = (preferredDateIso, timeslots) => {
  const preferredDate = formatDateFromIso(preferredDateIso.substring(0, 11));
  const preferredTimeslot = timeslots.find(ts => ts.date === preferredDate);

  return timeslots.indexOf(preferredTimeslot);
};
